/**
 * @file translation.js
 * @brief Provides the French translation catalogue for the frontend interface.
 */
const frTranslation = {
    language: {
        english: "EN",
        french: "FR",
        switchToEnglish: "Passer en anglais",
        switchToFrench: "Passer en français",
    },
    common: {
        loading: "Chargement...",
        saving: "Enregistrement...",
        cancel: "Annuler",
        save: "Enregistrer",
        edit: "Modifier",
        delete: "Supprimer",
        search: "Rechercher...",
        noImage: "Pas d'image",
        unknown: "Inconnu",
        pageOf: "Page {{page}} sur {{total}}",
        previous: "Précédent",
        next: "Suivant",
        clear: "Effacer",
        clearAll: "Tout effacer",
        resultCount_one: "{{count}} résultat",
        resultCount_other: "{{count}} résultats",
        listingCount_one: "{{count}} annonce trouvée",
        listingCount_other: "{{count}} annonces trouvées",
        selectedCount_one: "{{count}} sélectionnée",
        selectedCount_other: "{{count}} sélectionnées",
    },
    app: {
        redirecting: "Redirection...",
        authError: "Erreur d'authentification",
        signInMessage: "Connectez-vous pour parcourir et vendre vos objets en privé !",
        signIn: "Se connecter avec Keycloak",
        maintenanceTitle: "Maintenance en cours",
        maintenanceMessage: "Nous effectuons une maintenance. Veuillez r\u00e9essayer plus tard.",
    },
    header: {
        sell: "Vendre",
        moderation: "Modération",
        catalog: "Catalogue",
        settings: "Param\u00e8tres",
        favorites: "Favoris",
        messages: "Messages",
        profile: "Profil",
        logout: "Déconnexion",
        closeMenu: "Fermer le menu",
        openMenu: "Ouvrir le menu",
    },
    listingList: {
        searchFavorites: "Rechercher dans les favoris...",
        searchListings: "Rechercher des annonces...",
        clearSearch: "Effacer la recherche",
        toggleFilters: "Afficher les filtres",
        filters: "Filtres",
        location: "Lieu",
        category: "Catégorie",
        searchLabel: "Recherche",
        clearFilters: "Effacer les filtres",
        error: "Une erreur est survenue : {{message}}",
        noListings: "Aucune annonce trouvée.",
        emptySummary: "Essayez d'ajuster ou d'effacer vos filtres pour elargir les resultats.",
        noDescription: "Aucune description fournie pour cette annonce.",
        addToFavorites: "Ajouter aux favoris",
        removeFromFavorites: "Retirer des favoris",
        marketSectionTitle: "Annonces",
        favoritesSectionTitle: "Annonces enregistrees",
        viewListing: "Voir l'annonce",
    },
    listingForm: {
        loginRequired: "Connectez-vous pour créer une annonce.",
        title: "Créer une annonce",
        subtitle: "Remplissez les détails ci-dessous pour publier votre objet.",
        titleField: "Titre",
        titlePlaceholder: "ex. Locomotive HO échelle 1:87",
        descriptionField: "Description",
        descriptionPlaceholder: "Décrivez votre objet en détail...",
        priceField: "Prix (EUR)",
        categoryField: "Catégorie",
        locationField: "Lieu",
        selectCategory: "Choisir une catégorie",
        selectRootCategory: "Choisir une catégorie racine",
        selectSubCategory: "Choisir une sous-catégorie (niveau {{level}})",
        selectLocation: "Choisir un lieu",
        loadingCategories: "Chargement des catégories...",
        selectedCategoryPath: "Chemin sélectionné : {{path}}",
        photosCount: "Photos ({{count}}/6)",
        dropHere: "Déposez les images ici...",
        dropPrompt: "Glissez-deposez les images, ou cliquez pour parcourir",
        dropHint: "Max 6 images · JPG, PNG, WEBP",
        imageHint: "Glissez pour réordonner · La première image est la couverture",
        removeImage: "Supprimer l'image",
        cover: "Couverture",
        maxImagesAlert: "6 images maximum autorisées",
        titleTooLong: "Le titre doit contenir au maximum {{max}} caractères.",
        descriptionTooLong: "La description doit contenir au maximum {{max}} caractères.",
        charactersCount: "{{count}} / {{max}} caractères",
        saveDraft: "Enregistrer en brouillon",
        submitting: "Envoi...",
        submitApproval: "Soumettre pour approbation",
        publishDirectly: "Publier directement",
    },
    listingEdit: {
        title: "Modifier l'annonce",
        subtitle: "Mettez à jour les détails de votre annonce.",
        loading: "Chargement de l'annonce...",
        notAllowed: "Vous n'avez pas l'autorisation de modifier cette annonce.",
        reject: "Rejeter",
        approve: "Approuver",
    },
    listingDetails: {
        statuses: {
            draft: "Brouillon",
            pending: "En attente d'approbation",
            active: "Active",
            transactionInProgress: "Transaction en cours",
            paused: "En pause",
            sold: "Vendue",
            rejected: "Rejetée",
        },
        actions: {
            submitReview: "Soumettre à révision",
            pause: "Mettre en pause",
            resume: "Reprendre",
            markSold: "Marquer comme vendue",
            approve: "Approuver",
            reject: "Rejeter",
            delete: "Supprimer",
            back: "Retour",
            manageListing: "Gérer l'annonce",
            contactAndOffer: "Contacter le vendeur ou faire une offre",
        },
        deleteConfirm: "Supprimer cette annonce ?",
        loading: "Chargement de l'annonce...",
        error: "Erreur au chargement de l'annonce",
        notFound: "Annonce introuvable",
        clickToEnlarge: "Cliquer pour agrandir",
        byAuthor: "par {{name}}",
        removeFromFavorites: "Retirer des favoris",
        addToFavorites: "Ajouter aux favoris",
        transactionLocked: "Une transaction est en cours. La modification est verrouillee.",
    },
    contactSeller: {
        contact: "Contacter le vendeur",
        messageTo: "Message à {{name}}",
        placeholder: "Bonjour, je suis intéressé par \"{{title}}\"...",
        buyNow: "Acheter maintenant ({{price}} EUR)",
        offerPlaceholder: "Votre offre",
        sendOffer: "Envoyer une offre",
        offerInvalid: "Veuillez entrer un montant d'offre valide.",
        transactionInProgress: "Une transaction est déjà en cours pour cette annonce.",
        listingSold: "Cette annonce est déjà vendue.",
        transactionCreateError: "Impossible de créer la demande de transaction.",
        sendError: "Échec de l'envoi du message. Veuillez réessayer.",
        sending: "Envoi...",
        send: "Envoyer le message",
    },
    messages: {
        title: "Messages",
        listingLabel: "Annonce",
        search: "Rechercher...",
        noResults: "Aucun résultat.",
        noConversations: "Aucune conversation pour le moment.",
        selectConversation: "Sélectionnez une conversation pour commencer à discuter",
        reconnecting: "Reconnexion...",
        loading: "Chargement...",
        startConversation: "Démarrez la conversation !",
        dropImages: "Déposez les images pour les joindre",
        attachImages: "Joindre des images",
        writeMessage: "Écrivez un message...",
        messageTooLong: "Le message doit contenir au maximum {{max}} caractères.",
        charactersCount: "{{count}} / {{max}} caractères",
        fallbackListing: "Annonce #{{id}}",
        readDouble: "lu",
        readSingle: "envoyé",
        transaction: {
            title: "Transaction",
            summary: "{{kind}} à {{offeredPrice}} EUR - {{status}}",
            accept: "Accepter",
            refuse: "Refuser",
            confirmItemOk: "Confirmer que l'objet est conforme",
            actionError: "Impossible de traiter l'action de transaction.",
            kinds: {
                buy: "Achat",
                offer: "Offre",
            },
            statuses: {
                pending: "En attente",
                accepted: "Acceptée",
                refused: "Refusée",
                completed: "Terminée",
                cancelled: "Annulée",
            },
        },
    },
    transactionErrors: {
        default: "La demande de transaction a echoue.",
        offerPriceRequired: "Le montant de l'offre est requis.",
        offerPricePositive: "Le montant de l'offre doit etre superieur a 0.",
        buyShouldNotIncludeOffer: "Une demande d'achat ne doit pas inclure un montant d'offre personnalise.",
        cannotBuyOwnListing: "Vous ne pouvez pas demarrer une transaction sur votre propre annonce.",
        listingUnavailable: "Cette annonce n'est pas disponible pour les demandes de transaction.",
        transactionAlreadyInProgress: "Une transaction est deja en cours pour cette annonce.",
        onlySellerCanRespond: "Seul le vendeur peut repondre a cette transaction.",
        onlyPendingCanBeResponded: "Seules les transactions en attente peuvent recevoir une reponse.",
        transactionNoLongerPending: "Cette transaction n'est plus en attente.",
        listingNoLongerAvailableForAccept: "L'annonce n'est plus disponible pour accepter une transaction.",
        anotherTransactionAlreadyActive: "Une autre transaction est deja active pour cette annonce.",
        onlyBuyerCanConfirm: "Seul l'acheteur peut confirmer la fin de la transaction.",
        onlyAcceptedCanComplete: "Seules les transactions acceptees peuvent etre finalisees.",
        transactionNoLongerActive: "Cette transaction n'est plus active.",
        invalidDecision: "Decision invalide. Utilisez accepter ou refuser.",
    },
    notifications: {
        unsupported: "Les notifications ne sont pas prises en charge par ce navigateur.",
        httpsRequired: "Les notifications nécessitent HTTPS (ou localhost en développement).",
        someone: "Quelqu'un",
        attachment: "Vous a envoyé une pièce jointe",
        newMessageFrom: "Nouveau message de {{name}}",
        transactionTitle: "Mise à jour de transaction de {{name}}",
        transactionBody: "Statut de la transaction : {{status}}",
        transactionUpdated: "Mis à jour",
        newModerationListingTitle: "Nouvelle annonce à modérer",
        newModerationListingBody: "\"{{title}}\" a été soumise par {{author}}.",
        newModerationListingsTitle: "Nouvelles annonces à modérer",
        newModerationListingsBody: "{{count}} nouvelle(s) annonce(s) ont été ajoutée(s) à la file de modération.",
        moderationListingFallbackTitle: "Annonce sans titre",
    },
    account: {
        loadError: "Échec du chargement du profil",
        updateError: "Échec de la mise à jour du profil.",
        loading: "Chargement du profil...",
        title: "Mon compte",
        changeProfilePicture: "Changer la photo de profil",
        changePhoto: "Changer la photo",
        bio: "Bio",
        bioPlaceholder: "Parlez un peu de vous...",
        characters_one: "{{count}} caractère",
        characters_other: "{{count}} caractères",
        updatedSuccess: "Profil mis à jour avec succès !",
        saveProfile: "Enregistrer le profil",
        myListings: "Mes annonces",
    },
    accountListings: {
        title: "Mes annonces",
        newListing: "Nouvelle annonce",
        searchPlaceholder: "Rechercher mes annonces...",
        allStatuses: "Tous les statuts",
        selectAll: "Tout sélectionner",
        noListings: "Aucune annonce trouvée.",
        pause: "Pause",
        resume: "Reprendre",
        archive: "Archiver",
        unarchive: "Désarchiver",
        deleteSelectedConfirm: "Supprimer les annonces sélectionnées ?",
        deleteOneConfirm: "Supprimer cette annonce ?",
        statuses: {
            draft: "Brouillon",
            pending: "En attente d'approbation",
            rejected: "Rejetée",
            active: "Active",
            transactionInProgress: "Transaction en cours",
            paused: "En pause",
            sold: "Vendue",
            archived: "Archivée",
        },
    },
    moderation: {
        title: "Panneau de modération",
        overview: {
            tab: "Vue d'ensemble",
            subtitle: "Vue rapide des annonces, conversations et utilisateurs.",
            refresh: "Rafraîchir la vue",
            loadError: "Impossible de charger les données de synthèse.",
            pendingListings: "Annonces en attente",
            rejectedListings: "Annonces rejetées",
            activeListings: "Annonces actives",
            users: "Utilisateurs",
            conversations: "Conversations",
            unreadMessages: "Messages non lus",
            openQueue: "Ouvrir la file",
            reviewRejected: "Voir les rejetées",
            browseUsers: "Parcourir les utilisateurs",
            openMessages: "Ouvrir la messagerie",
            liveMarketplace: "Actuellement visibles sur la marketplace",
            followUpNeeded: "Nécessite un suivi modérateur",
            statusGraphTitle: "Répartition des statuts d'annonces",
            pressureGraphTitle: "Pression de modération",
            temporalGraphTitle: "Historique des annonces actives",
            temporalGraphCreatedHint: "{{days}} derniers jours des nouvelles annonces actives.",
            temporalGraphSnapshotHint: "Total actif estime sur {{days}} jours (base + nouvelles annonces actives).",
            temporalGraphCreatedAria: "Graphique temporel des nouvelles annonces actives",
            temporalGraphSnapshotAria: "Graphique temporel du total estime d'annonces actives",
            modeCreated: "Nouvelles actives/jour",
            modeSnapshot: "Total actif",
            pendingShare: "Part des annonces en attente",
            pendingShareHint: "{{pending}} en attente sur {{total}} annonces suivies",
            pendingShareAria: "Part des annonces en attente : {{percent}} pour cent",
            recentPending: "Dernières annonces en attente",
            noPendingRecent: "Aucune annonce en attente pour le moment.",
            recentConversations: "Conversations récentes",
            noConversations: "Aucune conversation pour le moment.",
            unreadCount_one: "{{count}} non lu",
            unreadCount_other: "{{count}} non lus",
        },
        pending: "En attente",
        rejected: "Rejetées",
        users: "Utilisateurs",
        searchUsers: "Rechercher des utilisateurs...",
        searchListings: "Rechercher des annonces...",
        approveAll: "Tout approuver",
        rejectAll: "Tout rejeter",
        clearSelection: "Effacer",
        selectAllOnPage: "Tout sélectionner sur la page",
        noListings: "Aucune annonce trouvée.",
        noUsers: "Aucun utilisateur trouvé.",
        approve: "Approuver",
        reject: "Rejeter",
        reapprove: "Re-approuver",
        view: "Voir",
        viewProfile: "Voir le profil",
        statuses: {
            pending: "En attente",
            active: "Active",
            rejected: "Rejetée",
        },
    },
    catalogAdmin: {
        title: "Gestion du catalogue",
        heroTitle: "Pilotez toute la taxonomie de la marketplace.",
        subtitle: "Parcourez les catégories depuis la racine, ouvrez les branches à la demande et gérez le catalogue sans précharger toute l'arborescence.",
        tabAriaLabel: "Sections du catalogue",
        locationsTab: "Lieux",
        locationsTabHint: "Villes et zones de remise",
        categoriesTab: "Catégories",
        categoriesTabHint: "Arborescence imbriquée",
        locations: "Lieux",
        categories: "Catégories",
        locationsSubtitle: "Tous les lieux d'annonces dans une liste filtrable.",
        categoriesSubtitle: "Commencez par les catégories racines, puis chargez chaque branche uniquement quand vous l'ouvrez.",
        newLocationPlaceholder: "Nouveau nom de lieu...",
        namePlaceholder: "Nom...",
        slugPlaceholder: "slug",
        searchLocations: "Rechercher un lieu",
        searchAllCategories: "Rechercher toutes les catégories",
        noParent: "Aucun parent",
        noParentTopLevel: "Aucun parent (niveau principal)",
        searchParentPlaceholder: "Rechercher une catégorie parente (optionnel)",
        searchingParents: "Recherche des catégories...",
        noParentResults: "Aucune catégorie correspondante.",
        clearParent: "Effacer le parent",
        parentSelected: "Parent sélectionné : {{name}}",
        add: "Ajouter",
        addLocation: "Ajouter le lieu",
        addCategory: "Ajouter la catégorie",
        adding: "Ajout...",
        saving: "Enregistrement...",
        save: "Enregistrer",
        cancel: "Annuler",
        edit: "Modifier",
        delete: "Supprimer",
        refresh: "Rafraîchir",
        topLevel: "Racine",
        path: "Chemin",
        previous: "Précédent",
        next: "Suivant",
        search: "Rechercher",
        noLocations: "Aucun lieu pour le moment.",
        noCategories: "Aucune catégorie pour le moment.",
        loadFailed: "Échec du chargement du catalogue.",
        loadChildrenFailed: "Échec du chargement des sous-catégories.",
        addLocationFailed: "Échec de l'ajout du lieu.",
        updateFailed: "Échec de la mise à jour.",
        deleteFailed: "Échec de la suppression.",
        addCategoryFailed: "Échec de l'ajout de la catégorie.",
        locationNameTooLong: "Le nom du lieu doit contenir au maximum {{max}} caractères.",
        categoryNameTooLong: "Le nom de la catégorie doit contenir au maximum {{max}} caractères.",
        categorySlugTooLong: "Le slug de la catégorie doit contenir au maximum {{max}} caractères.",
        deleteLocationConfirm: "Supprimer ce lieu ? Les annonces qui l'utilisent perdront leur lieu.",
        deleteCategoryConfirm: "Supprimer cette catégorie ? Les sous-catégories seront aussi supprimées.",
        totalLocations: "Lieux",
        topLevelCategories: "Niveau principal",
        loadedBranches: "Éléments chargés",
        openBranches: "Branches ouvertes",
        visibleRoots: "Racines visibles",
        childCount_one: "{{count}} enfant",
        childCount_other: "{{count}} enfants",
        loadMoreChildren: "Charger plus d'enfants",
        loadingChildren: "Chargement des enfants...",
        resultCount_one: "{{count}} résultat",
        resultCount_other: "{{count}} résultats",
    },
    localAuth: {
        login: "Connexion",
        register: "Inscription",
        username: "Nom d'utilisateur",
        email: "E-mail (optionnel)",
        password: "Mot de passe",
        or: "ou",
        loginFailed: "\u00c9chec de la connexion. V\u00e9rifiez vos identifiants.",
        registerFailed: "\u00c9chec de l'inscription. Veuillez r\u00e9essayer.",
    },
    siteSettings: {
        eyebrow: "Administration",
        title: "Param\u00e8tres du site",
        subtitle: "G\u00e9rez la configuration globale de la plateforme. Les modifications sont appliqu\u00e9es imm\u00e9diatement.",
        loadFailed: "\u00c9chec du chargement des param\u00e8tres.",
        saveFailed: "\u00c9chec de la sauvegarde des param\u00e8tres.",
        saved: "Param\u00e8tres sauvegard\u00e9s !",
        generalSection: "G\u00e9n\u00e9ral",
        generalSectionHint: "Identit\u00e9 et disponibilit\u00e9 de la plateforme.",
        authSection: "Authentification",
        authSectionHint: "Choisissez les m\u00e9thodes de connexion disponibles.",
        authSsoEnabled: "Authentification unique (SSO)",
        authSsoEnabledHint: "Permettre aux utilisateurs de se connecter via le fournisseur OIDC.",
        authLocalEnabled: "Comptes locaux",
        authLocalEnabledHint: "Permettre aux utilisateurs de s'inscrire et se connecter avec un nom d'utilisateur et un mot de passe.",
        listingsSection: "Annonces",
        listingsSectionHint: "Limites et visibilit\u00e9 des annonces de la marketplace.",
        siteName: "Nom du site",
        siteNameHint: "Affich\u00e9 dans l'en-t\u00eate et le titre du navigateur.",
        motd: "Message du jour",
        motdHint: "Affich\u00e9 en banni\u00e8re pour tous les utilisateurs. Laisser vide pour masquer.",
        maxListingImages: "Images max par annonce",
        maxListingsPerUser: "Annonces max par utilisateur",
        listingsPublic: "Annonces publiques",
        listingsPublicHint: "Lorsqu'activ\u00e9, les annonces actives sont visibles par les visiteurs sans connexion.",
        maintenanceMode: "Mode maintenance",
        maintenanceModeHint: "Lorsqu'activ\u00e9, les utilisateurs non-staff voient une page de maintenance.",
        ssoSection: "Authentification unique (SSO)",
        ssoSectionHint: "Remplacer le fournisseur OIDC par d\u00e9faut. Laisser vide pour utiliser les valeurs par d\u00e9faut. Les changements prennent effet au prochain chargement.",
        oidcAuthority: "URL de l'autorit\u00e9 OIDC",
        oidcAuthorityHint: "L'URL de l'\u00e9metteur du fournisseur OpenID Connect (ex : https://login.example.com/realms/myrealm).",
        oidcClientId: "Client ID OIDC",
        oidcClientIdHint: "L'identifiant client enregistr\u00e9 aupr\u00e8s du fournisseur OIDC.",
        oidcAlgorithm: "Algorithme de signature JWT",
        oidcAlgorithmHint: "L'algorithme utilis\u00e9 par le fournisseur OIDC pour signer les jetons (doit correspondre \u00e0 la configuration du fournisseur).",
        ssoReloadWarning: "Sauvegarder les changements SSO rechargera la page et vous devrez vous reconnecter.",
    },
    userProfile: {
        loginRequired: "Veuillez vous connecter.",
        loading: "Chargement du profil...",
        error: "Erreur : {{message}}",
        activeListings_one: "{{count}} annonce active",
        activeListings_other: "{{count}} annonces actives",
        editProfile: "Modifier le profil",
        avatarPreview: "aperçu avatar",
        saveChanges: "Enregistrer les modifications",
        noActiveListings: "Cet utilisateur n'a aucune annonce active.",
    },
};

export default frTranslation;
